import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_FCR: createAsyncActionConstants('FETCH_FCR'),
    RESET_FCR: createAsyncActionConstants('RESET_FCR'),
    FETCH_FCR_DETAILS: createAsyncActionConstants('FETCH_FCR_DETAILS'),
}